import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en, ml, type LanguageCode } from '@mahallu/shared';

const STORAGE_KEY = 'mahallu.lang';

function storedLanguage(): LanguageCode {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'ml' ? 'ml' : 'en';
  } catch {
    return 'en';
  }
}

export function setLanguage(code: LanguageCode): void {
  void i18n.changeLanguage(code);
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Private mode or blocked storage: the choice lasts for this visit only.
  }
}

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ml: { translation: ml } },
  lng: storedLanguage(),
  fallbackLng: 'en',
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
});
document.documentElement.lang = i18n.language;

export default i18n;
